/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { useHistory } from "react-router-dom";

import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { InvoiceModel } from "../../../../../domain/models/invoice";

import InvoiceForm from "../../../../../presentation/pages/developer/invoice/form";

import toastUtils from "../../../../../utils/ToastUtils";
import { getErrorMessage } from "../../../../../presentation/helpers";

import { makeRemoteDeveloperCompanies } from "../../../usecases/developer-companies/remote-developer-companies-factory";
import { makeRemoteInvoice } from "../../../usecases/invoice/remote-invoice-factory";

const MakeInvoiceCreate: React.FC = () => {
  const [developerCompaniesList, setDeveloperCompaniesList] = React.useState<
    DeveloperCompanyModel[]
  >([]);

  const history = useHistory();

  React.useEffect(() => {
    (async () => {
      const econ = await makeRemoteDeveloperCompanies().getByDeveloper();
      setDeveloperCompaniesList(econ);
    })();
  }, []);

  const parseCurrency = (val?: string): number =>
    Number(String(val ?? "").replaceAll(".", "").replaceAll(",", ".")) || 0;

  const handleSubmit = async (
    values: any,
    setShowConfirm: any,
  ): Promise<void> => {
    try {
      const payload: InvoiceModel = {
        companyName: values?.companyName,
        addressName: values?.addressName,
        city: values?.city,
        state: values?.state,
        nation: values?.nation,
        postalCode: values?.postalCode,
        bankName: values?.bankName,
        bankAgency: values?.bankAgency,
        bankAccount: values?.bankAccount,
        bankDigit: values?.bankDigit,
        serviceDescription: values?.serviceDescription,
        serviceValue: values?.serviceValue,
        total: parseCurrency(values?.serviceValue),
        currency: { id: Number(values?.currencyId) },
        developerCompany: { id: Number(values?.company) },
      };

      await makeRemoteInvoice().create(payload);
      setShowConfirm(true);
      setTimeout(() => {
        setShowConfirm(false);
        history.push("/invoice");
      }, 6000);
      toastUtils.showMessage({
        type: "success",
        message: "Invoice gerado com sucesso!",
      });
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: getErrorMessage(error),
      });
    }
  };

  return (
    <InvoiceForm
      loading={false}
      handleSubmit={handleSubmit}
      developerCompaniesList={developerCompaniesList}
    />
  );
};

export default MakeInvoiceCreate;
